import Link from "core-web/components/Link";
import React from "react";
import TextStyles from "theme/components/text/TextStyles";
import ThemeBadge from "theme/components/badges/ThemeBadge";
import ThemeButton from "theme/components/buttons/ThemeButton";
import decodeHTMLEntities from "core-web/utils/decodeHTMLEntities";
import { isObject } from "core-web/utils/object";
import styled from "theme/libs/styled";
import { useTranslation } from "react-i18next";
import { checkForLocalePrefix } from "core-web/utils/checkForLocalePrefix";

const Flex = styled("div")`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`;

const Badge = styled(ThemeBadge)`
    padding: 8px 12px;
    border-radius: 16px;

    &[data-should-break-spaces="true"] {
        white-space: break-spaces;
    }
`;

const Badges = ({ badges = [], badgesAsLinks = false, shouldBreakSpaces = false, ...rest }) => {
    const { t } = useTranslation();

    if (!badges?.length) {
        return null;
    }

    return (
        <Flex {...rest}>
            {badges.map((badge, index) => {
                if (!badge) {
                    return null;
                }

                let link, text;
                if (isObject(badge)) {
                    text = badge.label || badge.value || badge.name;
                    link = badgesAsLinks ? badge.url || badge.format?.permalink : null;
                } else {
                    text = badge;
                }

                if (text === "True") {
                    text = t("yes");
                }

                if (!text) {
                    return null;
                }

                const localPrefix = checkForLocalePrefix(link);
                const categorySlug = link.replace(`${localPrefix}/`, "");

                return link ? (
                    <ThemeButton
                        key={text + index}
                        buttonTheme="black_outlined"
                        size="sm"
                        as={Link}
                        to={categorySlug}
                        height="auto"
                        padding="8px 12px"
                        whiteSpace={shouldBreakSpaces && "break-spaces"}
                    >
                        <TextStyles textStyles="Myriad Pro/16-100">{decodeHTMLEntities(text)}</TextStyles>
                    </ThemeButton>
                ) : (
                    <Badge
                        key={text + index}
                        text={text}
                        textStyle="Myriad Pro/16-100"
                        badgeTheme="grey"
                        data-should-break-spaces={shouldBreakSpaces}
                    />
                );
            })}
        </Flex>
    );
};

export default Badges;
